import type { AppFeaturesConfig } from './featureFlagsSlice';
import FEATURES_CONFIG from './app-features-config.json';

/** Type representing all valid feature flag names derived from the config */
export type AppBaseFeatures = typeof FEATURES_CONFIG.BASE;
export type AppRegionalFeatures = Omit<typeof FEATURES_CONFIG, 'BASE'>;
export type AppFeatureName = keyof AppBaseFeatures;

export interface FeatureVisibilityInput {
  cropUuid?: string;
  countryCode: string;
  featureName: AppFeatureName;
  defaultFeatures: Record<string, boolean>;
  regionalFeatures: Record<string, Record<string, boolean>>;
  tokenFeatures: Record<string, boolean>;
  qaFeatures: Record<string, boolean>;
}

export const getIsFeatureVisible = ({
  countryCode,
  featureName,
  defaultFeatures,
  regionalFeatures,
  tokenFeatures,
  qaFeatures,
}: FeatureVisibilityInput): boolean => {
  const country = countryCode.toUpperCase();
  const defaultState = defaultFeatures[featureName];
  const regionalState = regionalFeatures[country]?.[featureName];
  const tokenState = tokenFeatures[featureName];
  const qaState = qaFeatures[featureName];

  if (qaState !== undefined) return !!qaState;
  if (tokenState !== undefined) return !!tokenState;
  if (regionalState !== undefined) return !!regionalState;
  if (defaultState !== undefined) return !!defaultState;

  return true;
};

export const splitFeaturesConfig = (config: AppFeaturesConfig | undefined) => {
  const defaultFeatures = config?.BASE ?? {};
  const regionalFeatures = Object.entries(config ?? {}).reduce<
    Record<string, Record<string, boolean>>
  >((result, [key, value]) => {
    if (key === 'BASE' || !value) return result;

    result[key] = value;
    return result;
  }, {});

  return { defaultFeatures, regionalFeatures };
};
